import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { CNMedication } from 'src/app/models/cnmedication';
import { CNTreatment } from 'src/app/models/cntreatment';
import { TreatmentService, TreatmentServiceFilter, TreatmentServiceSubject } from 'src/app/services/treatment.service';

@Component({
  selector: 'app-medication-list',
  templateUrl: './medication-list.component.html',
  styleUrls: ['./medication-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MedicationListComponent implements OnInit, OnDestroy {

  displayedColumns: string[] = ['medication'];
  public medications: (CNMedication | CNTreatment)[] = [];
  private subject: TreatmentServiceSubject;
  private myLocation = 'default';
  private myFilter = TreatmentServiceFilter.active_treatment;
  private clearSub: Subscription;
  private treatmentsSub: Subscription;

  constructor(public medicationservice: TreatmentService, private changeDetection: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.clearSub = this.medicationservice.clear.subscribe(flag => {
      console.log('medications cleared');
    });
  }

  ngOnDestroy(): void {
    this.clearSub.unsubscribe();
    this.treatmentsSub.unsubscribe();
  }

  @Input() set location(theLocation: string) {
    this.myLocation = theLocation;
    this.subject = this.medicationservice.getSubject(this.myLocation, this.myFilter, false);
    this.treatmentsSub = this.subject.treatments.subscribe(data => {
      this.medications = data;
      this.changeDetection.markForCheck();
    });
  }
}
